<div class="container">
    <app-header *ngIf="
        boardRetrievingService.displayHeader$() || 
        boardStateService.isGameStarted$() ||
        boardRetrievingService.isLoadingBoard$() ||
        boardStateService.gameCompleted$()
        "></app-header>
    <router-outlet />
</div>